<template>
	<div class="app-container">
		<el-dialog
			ref="dialog"
			:title="setTitle"
			:visible.sync="showDialog"
			width="50%"
			@close="closeDialog"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
		>
			<el-form
				:rules="rules"
				ref="form"
				:model="boxData"
				label-width="180px"
				:key="showType + currentId"
			>
				<el-form-item
					v-if="showType == 2 || boxData.parentId"
					prop="id"
					label="所属一级服务提供方式"
				>
					<div class="form-text" v-if="addAndEdit()">
						{{ showFirstText(currentId) }}
					</div>
					<div class="form-text" v-else>
						{{ showFirstText(boxData.parentId) }}
					</div>
				</el-form-item>
				<el-form-item
					v-if="showType != 2 && showType != 4 && showType != 6"
					prop="name"
					label="服务提供方式名称"
				>
					<el-input
						clearable
						maxlength="50"
						placeholder="请输入服务提供方式名称，限制50个字符"
						v-if="addAndEdit()"
						v-model.trim="boxData.name"
						@input="inputChange('name')"
					></el-input>
					<div class="form-text" v-else>
						{{ boxData.name }}
					</div>
				</el-form-item>
				<el-form-item v-else prop="name" label="二级服务提供方式">
					<el-select
						v-if="addAndEdit()"
						v-model="boxData.name"
						clearable
						placeholder="请选择二级服务提供方式"
						class="input-box"
						clearable
					>
						<el-option
							v-for="item in serviceList"
							:value="item.label"
							:key="item.label"
							:label="item.label"
						></el-option>
					</el-select>
					<div class="form-text" v-else>
						{{ boxData.name }}
					</div>
				</el-form-item>
				<el-form-item prop="code" label="服务提供方式编码">
					<el-input
						clearable
						maxlength="20"
						:disabled="showType == 3 || showType == 4"
						placeholder="请输入服务提供方式编码，只允许输入英文大写字母，限制20个字符"
						v-if="addAndEdit()"
						v-model.trim="boxData.code"
						@input="inputChange('code')"
					></el-input>
					<div class="form-text" v-else>
						{{ boxData.code }}
					</div>
				</el-form-item>
				<el-form-item label="服务提供方式说明">
					<el-input
						v-if="addAndEdit()"
						clearable
						show-word-limit
						type="textarea"
						placeholder="请输入服务提供方式说明，限制300个字符"
						maxlength="300"
						v-model.trim="boxData.modeDesc"
						@input="inputChange('modeDesc')"
					></el-input>
					<div class="form-text" v-else>
						{{ boxData.modeDesc }}
					</div>
				</el-form-item>
				<div v-if="addAndEdit()" class="button-box">
					<el-button @click="cancel">取消</el-button>
					<el-button @click="submit" type="primary">保存</el-button>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			var validateCode = (rule, value, callback) => {
				if (value == undefined) {
					callback(new Error("服务提供方式编码不能为空"));
				} else if (!this._valid._limitUpperEn(value)) {
					callback(new Error("只允许输入英文大写字母，限制20个字符"));
				} else {
					callback();
				}
			};
			let rules = {
				parentId: [
					{
						required: true,
						message: "请选择所属一级服务提供方式",
						trigger: "change",
					},
				],
				name: [
					{
						required: true,
						message: "服务提供方式名称不能为空，最多不超过50个字符",
						trigger: ["blur", "change"],
					},
				],
				code: [
					{
						required: true,
						validator: validateCode,
						trigger: ["blur", "change"],
					},
				],
			};
			return {
				showDialog: this.show,
				showType: this.type,
				currentId: this.current,
				serviceList: [
					{
						id: "1",
						label: "产品级",
					},
					{
						id: "2",
						label: "非产品级",
					},
				],
				boxData: {
					parentId: 0,
					code: "",
				}, // 数据
				rules, // 规则
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false,
			},
			detail: {
				type: Object,
				default: null,
			},
			type: {
				type: Number,
				default: 0, // 服务提供方式 1-新建一级 2-新建二级 3-编辑-级 4-编辑二级 5-查看一级 6-查看二级
			},
			current: {
				type: Number,
				default: 0, //如果增加二级，那么currentid就是新增的parentId
			},
		},
		computed: {
			setTitle: function () {
				switch (this.showType) {
					case 1:
						return "新增一级服务提供方式";
					case 2:
						return "新增二级服务提供方式";
					case 3:
						return "编辑一级服务提供方式";
					case 4:
						return "编辑二级服务提供方式";
					case 5:
						return "查看一级服务提供方式";
					case 6:
						return "查看二级服务提供方式";
				}
				return "";
			},
		},
		watch: {
			show: function (value) {
				this.showDialog = value;
			},
			detail: function (value) {
				this.editData = value;
				this.boxData = this.editData;
			},
			current(value) {
				this.currentId = value;
				this?.$refs?.form?.clearValidate && this.$refs.form.resetFields();
			},
			type(value) {
				this.showType = value;
				if (value == 2 || value == 4) {
					this.rules.name[0].message = "请选择二级服务提供方式";
				}
			},
		},
		methods: {
			closeDialog() {
				this.$emit("editReceive", {
					key: "showEdit",
					value: false,
				});
			},
			showFirstText(pid) {
				const data = this.$parent.treeList.find((el) => el.id === pid);
				console.log(data);
				if (data) {
					this.currentId = pid;
					return data?.name;
				}
			},
			inputChange(name) {
				let num;
				if (name === "code") {
					num = 20;
				} else if (name === "modeDesc") {
					num = 300;
				} else if (name === "name") {
					num = 50;
				}
				this.boxData[name] = this.boxData[name].slice(0, num);
			},
			/**
			 * 判断是编辑还是新建
			 * @returns {Boolean} true-编辑|新建 false-查看|其他
			 */
			addAndEdit() {
				return this.showType <= 4 && this.showType !== 0;
			},
			/**
			 * 清空数据
			 */
			clearBoxData() {
				this.boxData = {
					id: undefined,
					parentId: undefined,
					name: undefined,
					modeDesc: undefined,
				};
				this?.$refs?.form?.clearValidate && this.$refs.form.resetFields();
				this.$forceUpdate();
			},
			/**
			 * 点击取消
			 */
			cancel() {
				this?.$refs?.form?.clearValidate && this.$refs.form.resetFields();
				this.clearBoxData();
				this.closeDialog();
			},
			/**
			 * 右侧保存按钮
			 */
			async submit() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						const param = { ...this.boxData };
						if (this.showType == 2 || this.showType == 4) {
							param.parentId = this.currentId;
						}
						if (this.showType == 1 || this.showType == 3) {
							param.parentId = 0;
						}
						this.toDo(param);
						//这里区分添加一级还是二级TODO
					}
				});
			},
			async toDo(param) {
				const res = await this.axios.post(
					this.getApiUrl(
						this.showType === 3 || this.showType === 4
							? "serviceModeEdit"
							: "serviceModeCreate"
					),
					param,
					{
						toJSON: true,
					}
				);
				if (res.code === 1) {
					this.$message({
						type: "success",
						message:
							this.showType === 3 || this.showType === 4
								? "操作成功！"
								: "新建成功",
					});
					this.$emit("reload");
					this.closeDialog();
				} else {
					this.$message.warning(res.msg);
				}
			},
		},
		created() {
			var lett = this;
			document.onkeydown = function (e) {
				var key = window.event.keyCode;
				var button = document.querySelector(".dialog-btn");
				if (!button) return;
				if (key == 13) {
					lett.onSubmit("form");
				}
			};
		},
	};
</script>
<style rel="stylesheet/scss" lang="scss">
	.button-box {
		height: 100%;
		display: flex;
		justify-content: space-around;
	}
</style>